import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Subscription from "../components/Subscription";

const SubscriptionPage = () => {
  return (
    <>

      {/* MasterLayout */}
    
        {/* Breadcrumb */}
        <Breadcrumb title="Professional Situation" />

        <Subscription />

    
    </>
  );
};

export default SubscriptionPage; 